const mutations = {
  setTotal(state, total) {
    state.total = total;
  },
};

export default mutations;
